import { useState } from 'react'
import cx from 'classnames'
import { useTranslation } from 'next-i18next'
import * as Tooltip from '@radix-ui/react-tooltip'
import CopyToClipboard from 'react-copy-to-clipboard'

import { LinkIcon, ExternalLinkIcon } from 'icons'

const ShareButton = ({ onCopy }: { onCopy?: () => void }) => {
  const { t } = useTranslation(['common'])
  const [showToast, setShowToast] = useState(false)

  const localOnCopy = () => {
    if (typeof onCopy === 'function') {
      onCopy()
    }

    setShowToast(true)
    setTimeout(() => {
      setShowToast(false)
    }, 3000)
  }

  return (
    <div className="relative">
      <div
        aria-live="polite"
        className={cx(
          'absolute right-full top-1/2 mr-16 -translate-y-1/2',
          'flex items-center justify-between',
          'rounded-sm bg-teal-3 p-8 ',
          {
            'pointer-events-none translate-x-12 opacity-0': !showToast,
            transition: showToast,
          }
        )}
      >
        {showToast ? (
          <>
            <LinkIcon className="stroke-white rect-18" />
            <p className="ml-10 whitespace-nowrap text-14 font-semibold text-white">
              {t('ui.link-copied')}
            </p>
          </>
        ) : null}
      </div>
      <Tooltip.Root delayDuration={500}>
        <Tooltip.Trigger asChild>
          <div>
            <CopyToClipboard
              text={typeof window !== 'undefined' ? window.location.href : ''}
              onCopy={localOnCopy}
            >
              <button className="block">
                <span className="sr-only">Copy to Clipboard</span>
                <ExternalLinkIcon
                  aria-hidden="true"
                  className="stroke-teal-5 rect-24"
                />
              </button>
            </CopyToClipboard>
          </div>
        </Tooltip.Trigger>
        <Tooltip.Content
          alignOffset={-10}
          sideOffset={5}
          side="top"
          className={cx('rounded-sm bg-black px-16 py-8 shadow-sm')}
        >
          <p className="text-14 font-semibold text-white">
            {t('ui.copy-link')}
          </p>
          <Tooltip.Arrow className="fill-black" offset={10} />
        </Tooltip.Content>
      </Tooltip.Root>
    </div>
  )
}

export default ShareButton
